<template>
  <Transition name="qr-toast">
    <div
        v-if="notice"
        :key="notice.id"
        class="qr-toast alert alert-important mb-0"
        :class="alertClass"
        :role="notice.type === 'verified' ? 'status' : 'alert'"
        aria-live="polite"
        @click="dismissQrNotice"
    >
      <div class="d-flex align-items-center gap-2">
        <IconCircleCheck v-if="notice.type === 'verified'" :size="20" />
        <IconAlertTriangle v-else-if="notice.type === 'warning'" :size="20" />
        <IconShieldX v-else :size="20" />
        <div>{{ notice.text }}</div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { computed } from 'vue'
import { IconCircleCheck, IconAlertTriangle, IconShieldX } from '@tabler/icons-vue'
import { useQrNotice } from '@/composables/useQrNotice.js'

const { notice, dismissQrNotice } = useQrNotice()

const alertClass = computed(() => ({
  verified: 'alert-success',
  warning: 'alert-warning',
  blocked: 'alert-danger',
}[notice.value?.type] || 'alert-info'))
</script>

<style scoped>
/* Above QrScannerModal (1050) and the view modals: several flows close the
   scanner on success, and the notice has to outlive it. */
.qr-toast {
  position: fixed;
  top: calc(env(safe-area-inset-top, 0px) + 0.75rem);
  left: 50%;
  transform: translateX(-50%);
  width: min(92vw, 480px);
  z-index: 2000;
  box-shadow: var(--tblr-box-shadow-lg);
  cursor: pointer;
}

.qr-toast-enter-active,
.qr-toast-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.qr-toast-enter-from,
.qr-toast-leave-to {
  opacity: 0;
  transform: translate(-50%, -0.5rem);
}
</style>
